import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Button } from '_zari/core'

import { EstadosEnvioAsientos } from 'constants/index'

import { ZrSwal } from 'utils'

import * as Tables from './tables'

import * as AsientoContableService from 'services/asientosContables.service'

const CambioEstadoModal = ({ show, handleClose, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const [checkedRows, setCheckedRows] = React.useState([])

  const handleChange = React.useCallback(rowId => {
    setCheckedRows(prev => {
      let output = [...prev]
      if (output.some(x => x === rowId)) {
        output = output.filter(x => x !== rowId)
      } else {
        output.push(rowId)
      }

      return output
    })
  }, [])

  const actualizarEstadosxIds = React.useCallback(
    ids => {
      __zariContext.loader.open('Cambiando de estado a documentos.')
      AsientoContableService.actualizarMasivoEstadoEnvioxIds({ ids, estadoEnvio: EstadosEnvioAsientos.ENVIADO })
        .then(() => {
          __zariContext.snack('success', 'Documentos actualizados correctamente.')
          reloadTable()
          handleClose()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
        .finally(() => {
          __zariContext.loader.close()
        })
    },
    [__zariContext, handleClose, reloadTable]
  )

  const clickActualizarEstado = React.useCallback(() => {
    if (checkedRows.length === 0) {
      __zariContext.snack('warning', 'Seleccionar documentos a cambiar de estado')
      return
    }

    ZrSwal.showAlert({
      mensaje: `Desea cambiar el estado de ${checkedRows.length} documentos?`,
      tipo: 'info',
      showCerrar: true,
      onSuccess: () => {
        actualizarEstadosxIds(checkedRows)
      }
    })
  }, [__zariContext, checkedRows, actualizarEstadosxIds])

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>Cambiar estado de envio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tables.VentasTable checkedRows={checkedRows} handleChange={handleChange} />
      </Modal.Body>
      <Modal.Footer>
        <Button outline color='secondary' onClick={handleClose} tiny>
          Cerrar
        </Button>
        <Button onClick={clickActualizarEstado} tiny>
          Actualizar estado
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(CambioEstadoModal)
